import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertDialogService } from '../../../services/alert-dialog.service';
import { Confirm } from '../../../dialogs/confirm-dialog/confirm-dialog.component';

// Dialog di modifica anagrafica medico, a schermo intero con accordion per sezione
// (struttura ripresa da struttura_anagrafica_medico.xlsx, foglio "sezioni e ordine"),
// sullo stesso pattern visivo di GceDialogInvoiceFormComponent (Liquidazioni): un'area
// di testata sempre visibile + una serie di mat-expansion-panel con icona +/-.
// A differenza di Liquidazioni, qui il form non e' generato da un FormGroup bespoke con
// logica di calcolo: i controlli ricalcano 1:1 i campi di GceInvoicePerson, cosi' il
// payload di save() resta compatibile con GcePersonalDataComponent.onSave/onDelete/onRestore,
// passati qui come callback (vedi MAT_DIALOG_DATA) per non duplicare quella logica.
@Component({
  selector: 'app-gce-dialog-personal-data-form',
  templateUrl: './gce-dialog-personal-data-form.component.html',
  styleUrls: ['./gce-dialog-personal-data-form.component.css']
})
export class GceDialogPersonalDataFormComponent implements OnInit {
  person: any;
  form: FormGroup;
  submitted = false;

  panelGenerali = false;
  panelAlbo = false;
  panelProfessionali = false;
  panelAssicurazione = false;
  panelCollaborazioni = false;
  panelNav = false;

  sessoOptions: { key: string, value: string }[] = [
    { key: 'M', value: 'Maschio' },
    { key: 'F', value: 'Femmina' },
    { key: '', value: 'Non specificato' }
  ];

  constructor(
    public dialogRef: MatDialogRef<GceDialogPersonalDataFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private alertDialog: AlertDialogService
  ) {
    this.person = data.person || {};
  }

  ngOnInit() {
    this.form = this.fb.group({
      idfatturazione: [{ value: this.person.idfatturazione, disabled: true }],
      descrizione: [this.person.descrizione, Validators.required],
      data_nascita: [this.person.data_nascita],
      luogo_nascita: [this.person.luogo_nascita],
      sesso: [this.person.sesso],
      annullato: [{ value: this.person.annullato, disabled: true }],
      errore: [{ value: this.person.errore, disabled: true }],
      desc_errore: [{ value: this.person.desc_errore, disabled: true }],
      cessato: [this.person.cessato],

      email: [this.person.email, Validators.required],
      indirizzo_pec: [this.person.indirizzo_pec],
      piva: [this.person.piva, Validators.required],
      codice_iban: [this.person.codice_iban],
      indirizzo: [this.person.indirizzo, Validators.required],
      cap: [this.person.cap, Validators.required],
      citta: [this.person.citta, Validators.required],
      provincia: [this.person.provincia, Validators.required],
      regime_fiscale_invio_portale: [this.person.regime_fiscale_invio_portale, Validators.required],
      codice_fiscale: [this.person.codice_fiscale],
      telefono: [this.person.telefono],

      iscrizione_albo_medici: [this.person.iscrizione_albo_medici],
      iscrizione_albo_medici_prov: [this.person.iscrizione_albo_medici_prov],
      iscrizione_albo_odontoiatri: [this.person.iscrizione_albo_odontoiatri],
      iscrizione_albo_odontoiatri_prov: [this.person.iscrizione_albo_odontoiatri_prov],
      numero_iscrizione_albo_igienisti: [this.person.numero_iscrizione_albo_igienisti],
      data_iscrizione_albo: [this.person.data_iscrizione_albo],
      data_laurea: [this.person.data_laurea],
      laurea_luogo: [this.person.laurea_luogo],
      laurea_tipologia: [this.person.laurea_tipologia],
      laurea_specializzazione: [this.person.laurea_specializzazione],

      tipo_medico: [this.person.tipo_medico, Validators.required],
      ranking_operatore: [this.person.ranking_operatore],
      profilo_clinico: [this.person.profilo_clinico],
      aree_competenza_operatore: [this.person.aree_competenza_operatore],
      id_profilo_xdent: [this.person.id_profilo_xdent],
      profilo_compenso: [this.person.profilo_compenso],
      scadenza_blsd: [this.person.scadenza_blsd],
      scadenza_radioprotezione: [this.person.scadenza_radioprotezione],
      scadenza_rc_professionale: [this.person.scadenza_rc_professionale],
      massimale_rc_professionale: [this.person.massimale_rc_professionale],

      data_scadenza_assicurazione: [this.person.data_scadenza_assicurazione],
      nome_compagnia_assicurazione: [this.person.nome_compagnia_assicurazione],
      massimale_assicurazione: [this.person.massimale_assicurazione],

      data_inizio_collaborazione: [this.person.data_inizio_collaborazione],
      data_fine_collaborazione_gruppo: [this.person.data_fine_collaborazione_gruppo],
      modalita_collaborazione: [this.person.modalita_collaborazione],
      modalita_recesso: [this.person.modalita_recesso],
      motivo_recesso: [this.person.motivo_recesso],
      abilitato_estetica: [this.person.abilitato_estetica],

      fornitore_nav: [this.person.fornitore_nav, Validators.required],
      medico_portale: [{ value: this.person.medico_portale, disabled: true }],
      piva_portale: [{ value: this.person.piva_portale, disabled: true }],
      cfisc_portale: [{ value: this.person.cfisc_portale, disabled: true }],
      regime_portale: [{ value: this.person.regime_portale, disabled: true }],
      capitale_portale: [{ value: this.person.capitale_portale, disabled: true }],
      nome_nav: [{ value: this.person.nome_nav, disabled: true }],
      piva_nav: [{ value: this.person.piva_nav, disabled: true }],
      cfisc_nav: [{ value: this.person.cfisc_nav, disabled: true }],
      capitale_sociale_invio_portale: [this.person.capitale_sociale_invio_portale],
      dataora_invio_portale: [{ value: this.person.dataora_invio_portale, disabled: true }],
      esito_invio_portale: [{ value: this.person.esito_invio_portale, disabled: true }],
      messaggio_invio_portale: [{ value: this.person.messaggio_invio_portale, disabled: true }],
      flg_invio_dati_portale: [this.person.flg_invio_dati_portale],
      flg_nofattura_portale: [this.person.flg_nofattura_portale]
    });
  }

  // Opzioni dei campi select: riusa i lookup gia' caricati e assegnati alle colonne
  // in GcePersonalDataComponent.ngOnInit() (stesso meccanismo del vecchio <app-form>).
  getOptions(columnDef: string): { key: string, value: string }[] {
    const col = (this.data.columns || []).find(c => c.columnDef === columnDef);
    return (col && col.options) || [];
  }

  getActionColumns(): any[] {
    return (this.data.columns || []).filter(c => c.type === 'custom-action');
  }

  toggleSwitchValue(columnDef: string) {
    if (this.form.get(columnDef).disabled) { return; }
    this.form.get(columnDef).patchValue(!this.form.get(columnDef).value);
  }

  getSwitchValue(columnDef: string): boolean {
    return !!(this.form.get(columnDef) && this.form.get(columnDef).value);
  }

  onActionClick(field: any) {
    this.data.onCustomActionClick({ row: this.person, field: field });
  }

  save() {
    this.submitted = true;
    if (!this.form.valid) {
      this.alertDialog.open({
        title: "FORM.INVALIDSAVEDIALOG.TITLE",
        message: "FORM.INVALIDSAVEDIALOG.MESSAGE",
        isError: false,
        withTranslate: true
      });
      return;
    }
    this.data.onSave({ data: this.person, form: this.form, editing: this.data.editing, newRow: this.data.newRow });
  }

  deleteRow() {
    const confirm: Confirm = {
      title: "FORM.CONFIRMDIALOG.DELETE.TITLE",
      message: "FORM.CONFIRMDIALOG.DELETE.MESSAGE",
      buttonOkText: "FORM.CONFIRMDIALOG.DELETE.BUTTONOKTEXT",
      buttonCancelText: "FORM.CONFIRMDIALOG.DELETE.BUTTONCANCELTEXT",
      buttonOkStyle: { 'background-color': '#268B26' },
      buttonCancelStyle: { 'background-color': '#AA3939' },
      withTranslate: true
    };
    this.alertDialog.confirm(confirm).subscribe(result => {
      if (result) {
        this.data.onDelete(this.person);
      }
    });
  }

  cancel() {
    this.data.onRestore(this.person);
  }
}
